if (!window.CSA || typeof window.CSA !== 'object') {
  window.CSA = {}
}

// Media Queries - Keep in sync with _variables.scss!
CSA.mq = {
  desktop: '(min-width:1100px)'
}
